import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ModalController, ActionSheetController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoCaixaLancamentoPage } from '../grupo-caixa-lancamento/grupo-caixa-lancamento.page';
import { GrupoCaixaTransferenciaPage } from '../grupo-caixa-transferencia/grupo-caixa-transferencia.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { MoneyPipe } from 'src/app/pipes/money/money';

@Component({
  selector: 'app-grupo-caixa',
  templateUrl: './grupo-caixa.page.html',
  styleUrls: ['./grupo-caixa.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent,
    MoneyPipe
  ],
})
export class GrupoCaixaPage implements OnInit {
  grupoCaixa: any = { grupoCaixaLancamento: [] };
  pagination: any = { currentPage: 0 };
  lancamentos: any = [];
  idGrupoCaixa: any = "";
  idGrupo: any = "";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public loadingController: LoadingController,
    private translate: TranslateService,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController
  ) {

    this.idGrupo = this.navParams.get('idGrupo');
    this.grupoProvider.getGrupoCaixa(this.idGrupo).subscribe((data) => {
      this.grupoCaixa = data;
      this.idGrupoCaixa = data.id;
      this.loadLancamentos(null);
    });

  }

  ngOnInit() {}

  loadLancamentos(infiniteScroll: { target: { complete: () => void; }; } | null) {
    if (this.idGrupoCaixa) {
      this.pagination.currentPage++;
      this.grupoProvider.getLancamentos(this.idGrupoCaixa, this.pagination).subscribe(res => {
        this.lancamentos = this.lancamentos.concat(res.lancamentos);
        this.pagination = res.pagination;
        if (infiniteScroll)
          infiniteScroll.target.complete();
      });
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async abrirLancamento(tipo: any) {
    var data = { idGrupo: this.idGrupo, tipo: tipo, idGrupoCaixa: this.idGrupoCaixa };
    const modalPage = await this.modalCtrl.create({ component: GrupoCaixaLancamentoPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      //buscar saldo
      this.buscarSaldo();
      //reload nos lancamentos
      this.pagination = { currentPage: 0 };
      this.lancamentos = [];
      this.loadLancamentos(null);
    }
  }

  buscarSaldo() {
    this.grupoProvider.getGrupoCaixa(this.idGrupo).subscribe((data) => {
      this.grupoCaixa = data;
    });
  }

  async detalhesLancamento(lancamento: any) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('Opções'),
      buttons: [
        {
          text: this.translate.instant('Remover Lançamento'),
          handler: () => {
            this.remover(lancamento);
          }
        },
        {
          text: this.translate.instant('Cancelar'),
          handler: () => {
            actionSheet.dismiss();
          }
        }

      ]
    });

    actionSheet.present();
  }

  async remover(lancamento: { lancamentoOfertas: { idLancamento: any; }; id: any; }) {

    if (lancamento.lancamentoOfertas && lancamento.lancamentoOfertas.idLancamento) {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Erro'),
        message: this.translate.instant('A transferência já foi conferida por sua igreja'),
        buttons: [
          {
            text: this.translate.instant('Cancelar'),
            handler: () => { }
          }
        ]
      });

      alert.present();
    } else {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Atenção'),
        message: this.translate.instant('Confirmar exclusão?'),
        buttons: [
          {
            text: this.translate.instant('Cancelar'),
            handler: () => { }
          },
          {
            text: this.translate.instant('Sim'),
            handler: () => {

              this.grupoProvider.removerLancamento(lancamento.id).subscribe((data) => {
                //buscar saldo
                this.buscarSaldo();
                //reload nos lancamentos
                this.pagination = { currentPage: 0 };
                this.lancamentos = [];
                this.loadLancamentos(null);
              });

            }
          }
        ]
      });

      alert.present();
    }

  }

  async abrirTransferencia(tipo: any) {
    var data = { idGrupo: this.idGrupo, idGrupoCaixa: this.idGrupoCaixa };
    const modalPage = await this.modalCtrl.create({ component: GrupoCaixaTransferenciaPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      //buscar saldo
      this.buscarSaldo();
      //reload nos lancamentos
      this.pagination = { currentPage: 0 };
      this.lancamentos = [];
      this.loadLancamentos(null);
    }
  }
}
